export default __webpack_public_path__ + "static/media/HowItWorks_Step1_EN.9ab83594.png";